import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false,
    apiSendMail: '../../sendmail.php',
    colors: {
      white: '#FFFFFF',
      black: '#000000',
      buttons: {
        success: '#10940c'
      }
    },
    mainLinks: [
      {title: 'Главная', icon: 'home', url: '/'},
      {title: 'Малина', icon: 'hot_tub', url: '/malina'},
      {title: 'Садко', icon: 'hot_tub', url: '/sadko'}
      // {title: 'Акрополь', icon: 'hot_tub', url: '/acropolis'}
    ],
    malinaLinks: [
      {title: 'Сауны и хаммам', icon: 'hot_tub', url: '/malina/hammams'},
      {title: 'Номера', icon: 'local_hotel', url: '/malina/rooms'},
      {title: 'Отзывы', icon: 'forum', url: {hash: '#reviews'}},
      {title: 'Акции', icon: 'sentiment_satisfied_alt', url: '/malina/actions'},
      {title: 'Контакты', icon: 'place', url: {hash: '#contacts'}}
    ],
    sadkoLinks: [
      {title: 'Сауна', icon: 'hot_tub', url: '/sadko/hammam/1'},
      // {title: 'Номера', icon: 'local_hotel', url: '/sadko/rooms'},
      {title: 'Отзывы', icon: 'forum', url: {hash: '#reviews'}},
      {title: 'Акции', icon: 'sentiment_satisfied_alt', url: '/sadko/actions'},
      {title: 'Контакты', icon: 'place', url: {hash: '#contacts'}}
    ],
    acropolisLinks: [
      {title: 'Сауны', icon: 'hot_tub', url: '/acropolis/hammams'},
      {title: 'Апартаменты', icon: 'local_hotel', url: '/acropolis/room/1'},
      {title: 'Кафе', icon: 'local_hotel', url: '/acropolis/cafe'},
      {title: 'Отзывы', icon: 'forum', url: {hash: '#reviews'}},
      {title: 'Акции', icon: 'sentiment_satisfied_alt', url: '/acropolis/actions'},
      {title: 'Контакты', icon: 'place', url: {hash: '#contacts'}}
    ],
    malinaRooms: [
      {
        id: '1',
        img: '/static/img/rooms/malina/1/1.jpg',
        images: [
          '/static/img/rooms/malina/1/1.jpg',
          '/static/img/rooms/malina/1/2.jpg',
          '/static/img/rooms/malina/1/3.jpg',
          '/static/img/rooms/malina/1/4.jpg'
        ],
        index: null,
        name: 'Номер с сауной №1',
        description: 'В номере присутствует: Wi-Fi, сауна, 2х спальная кровать, кондиционер, телевизор.',
        description2: `В номере присутствует:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - 2х спальная кровать<br>
                      - Кондиционер<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'В вашем распоряжении полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '300 руб./час',
        price2: '1200 руб./12 часов',
        price3: '2000 руб./сутки'
      },
      {
        id: '2',
        img: '/static/img/rooms/malina/2/1.jpg',
        images: [
          '/static/img/rooms/malina/2/1.jpg',
          '/static/img/rooms/malina/2/2.jpg',
          '/static/img/rooms/malina/2/3.jpg',
          '/static/img/rooms/malina/2/4.jpg'
        ],
        index: null,
        name: 'Номер с сауной №2',
        description: 'В номере присутствует: Wi-Fi, сауна, 2х спальная кровать, кондиционер, телевизор.',
        description2: `В номере присутствует:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - 2х спальная кровать<br>
                      - Кондиционер<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'В вашем распоряжении полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '300 руб./час',
        price2: '1200 руб./12 часов',
        price3: '2000 руб./сутки'
      },
      {
        id: '3',
        img: '/static/img/rooms/malina/3/1.jpg',
        images: [
          '/static/img/rooms/malina/3/1.jpg',
          '/static/img/rooms/malina/3/2.jpg',
          '/static/img/rooms/malina/3/3.jpg',
          '/static/img/rooms/malina/3/4.jpg'
        ],
        index: null,
        name: 'Номер с джакузи',
        description: 'В номере присутствует: Wi-Fi, сауна, джакузи, 2х спальная кровать, кондиционер, телевизор.',
        description2: `В номере присутствует:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Джакузи<br>
                      - 2х спальная кровать<br>
                      - Кондиционер<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'В вашем распоряжении полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '500 руб./час',
        price2: ' ',
        price3: 'Данный номер не сдается на сутки!'
      }
    ],
    malinaHammams: [
      {
        id: '1',
        img: '/static/img/sauna/malina/1/1.jpg',
        images: [
          '/static/img/sauna/malina/1/1.jpg',
          '/static/img/sauna/malina/1/2.jpg',
          '/static/img/sauna/malina/1/3.jpg',
          '/static/img/sauna/malina/1/4.jpg'
        ],
        index: null,
        name: 'Сауна без бассейна',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, телевизор.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая<br>
                      - Массажное кресло`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '600 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час',
        price4: 'простыня махровая - 100 руб.',
        price5: 'тапочки одноразовые - 50 руб.',
        price6: 'тапочки махровые - 100 руб.',
        price7: 'веник березовый - 200 руб.'
      },
      {
        id: '2',
        img: '/static/img/sauna/malina/2/1.jpg',
        images: [
          '/static/img/sauna/malina/2/1.jpg',
          '/static/img/sauna/malina/2/2.jpg',
          '/static/img/sauna/malina/2/3.jpg',
          '/static/img/sauna/malina/2/4.jpg'
        ],
        index: null,
        name: 'Сауна с бассейном',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, бассейн, телевизор, массажное кресло.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Бассейн<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '800 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час',
        price4: 'простыня махровая - 100 руб.',
        price5: 'тапочки одноразовые - 50 руб.',
        price6: 'тапочки махровые - 100 руб.',
        price7: 'веник березовый - 200 руб.'
      },
      {
        id: '3',
        img: '/static/img/sauna/malina/3/1.jpg',
        images: [
          '/static/img/sauna/malina/3/1.jpg',
          '/static/img/sauna/malina/3/2.jpg',
          '/static/img/sauna/malina/3/3.jpg',
          '/static/img/sauna/malina/3/4.jpg'
        ],
        index: null,
        name: 'Хаммам',
        description: 'В нашем гостинично-банном комплексе имеется 2 хаммама.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '800 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час',
        price4: 'простыня махровая - 100 руб.',
        price5: 'тапочки одноразовые - 50 руб.',
        price6: 'тапочки махровые - 100 руб.',
        price7: 'веник березовый - 200 руб.'
      }
    ],
    sadkoHammams: [
      {
        id: '1',
        img: '/static/img/sauna/sadko/1/1.jpg',
        images: [
          // '/static/img/sauna/sadko/1/1.jpg',
          // '/static/img/sauna/sadko/1/2.jpg',
          // '/static/img/sauna/sadko/1/3.jpg',
          // '/static/img/sauna/sadko/1/4.jpg'
          '/static/img/sauna/sadko/1/2-1.jpeg',
          '/static/img/sauna/sadko/1/2-2.jpeg',
          '/static/img/sauna/sadko/1/2-3.jpeg',
          '/static/img/sauna/sadko/1/2-4.jpeg'
        ],
        index: null,
        name: 'Сауна c бассейном',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, телевизор.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Бассейн<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Кондиционер<br>
                      - Туалет<br>
                      - Душевая<br>
                      - Массажное кресло<br>
                      - Русский бильярд, размер 10, стол на камне`,
        description3: 'Наша сауна вмещает до 25 человек, поэтому Вы можете прийти не один, а в составе той компании, с кем Вам будет приятно, удобно и хорошо проводить время. ' +
            'После того, как попаритесь, можете окунуться в бассейн. Прохладная вода охладит Ваше тело до комнатной температуры, придаст Вам новых сил, энергии и бодрости. ' +
            'Вода в бассейне проходит обязательную ежедневную очистку. Мы используем в данном процессе самые современные средства и технологии. ' +
            'На отдыхе Вы можете поиграть в русский бильярд а также попеть в караоке.<br><br>' +
            'Скидка именинникам 10%.',
        price: '2000 руб./час (до 8-ми человек включительно)',
        price2: '2000 руб./час (до 8-ми человек включительно)',
        price3: 'за каждого последующего - 50 руб./час',
        price4: 'бильярд - 200 руб./час',
        price5: 'простыня махровая - 100 руб.',
        price6: 'тапочки одноразовые - 100 руб.'
      }
    ],
    acropolisHammams: [
      {
        id: '1',
        img: '/static/img/sauna/acropolis/1/v2-1.jpg',
        images: [
          '/static/img/sauna/acropolis/1/v2-1.jpg',
          '/static/img/sauna/acropolis/1/v2-2.jpg',
          '/static/img/sauna/acropolis/1/v2-3.jpg',
          '/static/img/sauna/acropolis/1/v2-4.jpg'
        ],
        index: null,
        name: 'Античная сауна',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, бассейн, телевизор.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Бассейн<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '950 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час',
        priceDescription: '(до 6-ти человек включительно, за каждого последующего 50 руб./час)'
      },
      {
        id: '2',
        img: '/static/img/sauna/acropolis/2/1.jpg',
        images: [
          '/static/img/sauna/acropolis/2/1.jpg',
          '/static/img/sauna/acropolis/2/2.jpg',
          '/static/img/sauna/acropolis/2/3.jpg'
        ],
        index: null,
        name: 'Русская сауна',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, бассейн, телевизор.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Бассейн<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '750 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час'
      },
      {
        id: '3',
        img: '/static/img/sauna/acropolis/3/1.jpg',
        images: [
          '/static/img/sauna/acropolis/3/1.jpg',
          '/static/img/sauna/acropolis/3/2.jpg',
          '/static/img/sauna/acropolis/3/3.jpg',
          '/static/img/sauna/acropolis/3/4.jpg'
        ],
        index: null,
        name: 'Японская сауна',
        description: 'В вашем распоряжении: Wi-Fi, сауна, душ, комната отдыха, бассейн, телевизор.',
        description2: `В вашем распоряжении:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - Сауна<br>
                      - Бассейн<br>
                      - Комната отдыха<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'Так же у нас присутствует полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '750 руб./час',
        price2: 'бильярд - 150 руб./час',
        price3: 'караоке - 150 руб./час'
      }
    ],
    acropolisRooms: [
      {
        id: '1',
        img: '/static/img/rooms/acropolis/1/1.jpg',
        images: [
          '/static/img/rooms/acropolis/1/1.jpg',
          '/static/img/rooms/acropolis/1/2.jpg',
          '/static/img/rooms/acropolis/1/3.jpg',
          '/static/img/rooms/acropolis/1/4.jpg'
        ],
        index: null,
        name: 'Апартаменты',
        description: 'В номере присутствует: Wi-Fi, сауна, 2х спальная кровать, кондиционер, телевизор.',
        description2: `В номере присутствует:<br>
                      - Бесплатный трансфер<br>
                      - Wi-Fi<br>
                      - 2х спальная кровать<br>
                      - Телевизор<br>
                      - Туалет<br>
                      - Душевая`,
        description3: 'В вашем распоряжении полноценная кухня, выбирайте любое блюдо из нашего меню и повар приготовит вам в течении 30 минут!',
        price: '500 руб./час',
        price2: '1200 руб./12 часов',
        price3: '2000 руб./сутки'
      }
    ]
  },
  mutations: {
    showDrawer (state) {
      state.drawer = !state.drawer
    }
  },
  getters: {
    colors (state) {
      return state.colors
    },
    malinaRoomById (state) {
      return roomId => {
        return state.malinaRooms.find(room => room.id === roomId)
      }
    },
    malinaHammamById (state) {
      return hammamId => {
        return state.malinaHammams.find(hammam => hammam.id === hammamId)
      }
    },
    sadkoHammamById (state) {
      return hammamId => {
        return state.sadkoHammams.find(hammam => hammam.id === hammamId)
      }
    },
    acropolisHammamById (state) {
      return hammamId => {
        return state.acropolisHammams.find(hammam => hammam.id === hammamId)
      }
    },
    acropolisRoomById (state) {
      return roomId => {
        return state.acropolisRooms.find(room => room.id === roomId)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js